import { registerMockAPI } from '~/mocks/mockApis';

import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetReceivingProgressDownloadParams } from '~/types/receive.types';

const fetchReceivingProgressDownload = async ({
  ownerCode,
  ...params
}: TypeGetReceivingProgressDownloadParams): Promise<void> => {
  const response = await axiosInstance.get(
    `${API_ENDPOINT.RECEIVE.GET_RECEIVING_PROGRESS_DOWNLOAD}/${ownerCode}/progress/download`,
    {
      params,
      responseType: 'blob',
    }
  );

  downloadBlobDataFile(response);
};

/**
 * [입고관리 > 입고현황] 입고현황 엑셀 다운로드 Mutation Hook
 */
export const useGetReceivingProgressDownloadMutation = () => {
  return useDownloadMutation(fetchReceivingProgressDownload);
};

registerMockAPI<null>({
  method: 'get',
  endpoint: '/api-inbound/v1/3pl/receiving/:ownerCode/progress/download',
  label: '입고/입고현황/목록다운로드',
  scenarios: [
    { name: '정상 응답', response: null },
    {
      name: '서버 오류',
      response: { error: { message: '입고현황 목록 다운로드 중 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
